import { defineComponent as _defineComponent } from 'vue'
import { useCadastroParecerReferencialStore } from '../../store/CadastroParecerReferencialStore';
import { storeToRefs } from 'pinia';
import CardExpand from '@/views/components/CardExpand.vue';
import { ParecerReferencialRenovacao } from '../../types';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposAlteracaoData',
  emits: ['click:alterar-datas'],
  setup(__props, { emit }) {

const store = useCadastroParecerReferencialStore();
const { listaRenovacao } = storeToRefs(store);

const ultimoRegistroMarcadoExcluir = computed(() => {
  return listaRenovacao.value.findLastIndex((item) => item.excluir);
});

const qtListaAposExclusao = computed(() => {
  return listaRenovacao.value.filter((item) => !item.excluir).length;
});



const headers = [
  {
    text: 'Data Alteração',
    value: 'dtRenovacao',
    align: 'center',
    width: '130px',
  },
  {
    text: 'Aprovação da Presidência',
    value: 'dtParecer',
    align: 'center',
    width: '200px',
  },
  {
    text: 'Data Validade',
    value: 'dtValidade',
    align: 'center',
    width: '130px',
  },
  {
    text: 'Usuário',
    value: 'cdUsuario',
  },
  {
    text: 'Setor',
    value: 'deSetor',
    width: '150px',
  },
  {
    text: 'Ação',
    value: 'acao',
    width: '50px',
    align: 'center',
  },
];

const excluirRenovacao = (index: number) => {
  const item = listaRenovacao.value[index];

  if (item.cdParRefRenovacao) {
    listaRenovacao.value.splice(index, 1, { ...item, excluir: !item.excluir });
    return;
  }

  listaRenovacao.value.splice(index, 1);
};

function getRowClass(item: ParecerReferencialRenovacao) {
  if (item.excluir) {
    return 'deletar';
  }

  return '';
}

function disableItem(item: ParecerReferencialRenovacao): boolean {
  const itemIndex = listaRenovacao.value.indexOf(item);

  if (item.excluir) {
    // Somente pode desmarcar se o item for o último marcado para exclusão
    return ultimoRegistroMarcadoExcluir.value !== itemIndex;
  }

  // Somente pode marcar se:
  // - O item for o próximo após o último marcado para exclusão
  const isNextAfterLastExcluded =
    ultimoRegistroMarcadoExcluir.value + 1 === itemIndex;
  // - Não for o último item da lista a ser marcado
  const isSingleItemAfterExclusion = qtListaAposExclusao.value === 1;

  return !isNextAfterLastExcluded || isSingleItemAfterExclusion;
}

return { __sfc: true,store, listaRenovacao, ultimoRegistroMarcadoExcluir, qtListaAposExclusao, emit, headers, excluirRenovacao, getRowClass, disableItem, CardExpand }
}

})